import { render, staticRenderFns } from "./undevelopedPage.vue?vue&type=template&id=7761d3de&scoped=true"
import script from "./undevelopedPage.vue?vue&type=script&lang=js"
export * from "./undevelopedPage.vue?vue&type=script&lang=js"
import style0 from "./undevelopedPage.vue?vue&type=style&index=0&id=7761d3de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7761d3de",
  null
  
)

export default component.exports